<div class="pagination">
  <ul>
    <li><a href="#">Anterior</a></li>
    <li class="dots">{{ page }}</li>
    <li><a href="#">Próxima</a></li>
  </ul>
</div>
